export default "__VITE_ASSET__DkINNM1T__"